import YFormProductTagging from './ProductTagging';

export { YFormProductTagging };
export default YFormProductTagging;
